import axios from 'axios';

const instance = axios.create({
  // baseURL        : (process.env.VUE_APP_API_URL !== undefined) ? process.env.VUE_APP_API_URL : '/api/',
  baseURL        : process.env.VUE_APP_BASE_URL + '/api',
  withCredentials: true,
});

export const baseURL = (process.env.VUE_APP_API_URL !== undefined) ? process.env.VUE_APP_API_URL : '/api/';

export const post = async (url, data = {}) => (await instance.post(url, data));
export const remove = async (url, data = {}) => (await instance.delete(url, data));
export const patch = async (url, data = {}) => (await instance.patch(url, data));
export const put = async (url, data = {}) => (await instance.put(url, data));
export const get  = async (url, params) => (await instance.get(url, {params}));
